// extracted by mini-css-extract-plugin
export default {"containerTags":"Tag_containerTags__risRY","tag":"Tag_tag__vfKro","text":"Tag_text__HDt7B"};